import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Copy2Icon, Typography } from '@blade/ui-kit'
import { type CurrencyModel } from '@root/entities/currency'
import { CurrencyIcon } from '@root/entities/currency/ui'
import { PairBoostersBadge } from '@root/entities/pair/ui'
import { PairRank } from '@root/entities/pair/ui/pair-rank'
import { useClipboard } from '@root/shared'
import { Truncate } from '@root/shared/ui-kit'

import { premiumFontCss } from '../constants'

import type { PremiumMetaModel } from '../../atoms'

type Props = {
  currency: CurrencyModel
  premium: PremiumMetaModel
}

export const PremiumCardHeader: React.FC<Props> = ({ premium, currency }) => {
  const { t } = useTranslation()

  const { copyToClipboard } = useClipboard()

  const handleCopy = () => {
    copyToClipboard(currency.address, {
      showSnackbar: true,
      snackbarText: t('currency.token_address_copied_message', {
        ticker: currency.ticker,
      }),
    })
  }

  return (
    <Root>
      <CurrencyIcon withNetwork currency={currency} size={38} />
      <Info>
        <InfoTop>
          <Name ellipsis>{currency.title}</Name>
          <PairRank rank={8} />
          <PairBoostersBadge currency={currency} premiumInfo={premium} />
        </InfoTop>
        <Address type="button" onClick={handleCopy}>
          <Ticker>{currency.ticker}</Ticker>
          <Truncate start={5} end={4}>
            {currency.address}
          </Truncate>
          <Icon>
            <Copy2Icon size={12} />
          </Icon>
        </Address>
      </Info>
    </Root>
  )
}

export const Root = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px;
  align-items: center;
`
export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`
export const InfoTop = styled.div`
  display: flex;
  align-items: center;
  gap: 3px 6px;
  flex-wrap: wrap;
`

export const Name = styled(Typography).attrs({
  variant: 'body4-bold',
  component: 'span',
})`
  text-transform: uppercase;

  ${premiumFontCss}
`

export const Ticker = styled(Typography).attrs({
  variant: 'body4-medium',
  component: 'span',
})``

export const Address = styled.button`
  all: unset;
  cursor: pointer;
  color: var(--text-11);

  font-size: var(--typography-description-semi-bold-font-size);
  line-height: var(--typography-description-semi-bold-line-height);
  font-weight: var(--typography-description-semi-bold-font-weight);

  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
`
export const Icon = styled.span`
  flex: 0 0;
`
